import { ApiProperty } from '@nestjs/swagger';
import { OrdenesTransporteConsolidadoItemDto } from './ordenes-transporte-consolidado-item.dto';

/**
 * DTO de respuesta para el Excel Consolidado de Órdenes de Transporte Agencia.
 * Sin paginación — el listado completo (hasta el límite) se usa para generar el archivo.
 */
export class OrdenesTransporteConsolidadoResponseDto {
  @ApiProperty({
    description: 'Filas del consolidado, una por contenedor',
    type: [OrdenesTransporteConsolidadoItemDto],
  })
  data!: OrdenesTransporteConsolidadoItemDto[];

  @ApiProperty({ description: 'Cantidad total de filas retornadas', example: 842 })
  total!: number;

  @ApiProperty({
    description: 'Timestamp de la respuesta',
    example: '2026-08-02T12:00:00.000Z',
  })
  timestamp!: string;
}
